import { useQuery } from '@tanstack/react-query';

import type { MarketApps } from '@/features/dashboard';

import { marketsOptions } from './markets.options';

export const useMarketQuery = (marketId: string | undefined) => {
  return useQuery(marketsOptions.market(marketId));
};

export const useMarketWidgets = (marketId: string | null) => {
  return useQuery(marketsOptions.widgets(marketId));
};

export const useMarketPreview = (template: MarketApps | undefined, enabled = true) => {
  return useQuery(marketsOptions.preview(template, enabled));
};
